// Based on solution from https://jsfiddle.net/ianclark001/rkocah23/

/**
 * Fixes anchor jumps, so that anchors are not hidden by navigation.
 */
var AnchorJumps = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	var HISTORY_SUPPORT = !!( window.history && window.history.pushState );
	var ANCHOR_REGEX  = /^#[^ ]+$/;
	var OFFSET_HEIGHT_PX = 100;

	function constructor() {
		jQuery( document ).ready( this.init.bind( this ) );
	};

	/**
	 * Establish events, and fix initial scroll position if a hash is provided.
	 */
	p.init = function() {
		this.scrollToCurrent();
		jQuery( window ).on( 'hashchange', this.scrollToCurrent.bind( this ) );
		jQuery('body').on( 'click', 'a', this.delegateAnchors.bind( this ) );
	};

	/**
	 * Return the offset amount to deduct from the normal scroll position.
	 * Modify as appropriate to allow for dynamic calculations
	 */
	p.getFixedOffset = function() {
		return OFFSET_HEIGHT_PX;
	};

	/**
	 * If the provided href is an anchor which resolves to an element on the
	 * page, scroll to it.
	 *
	 * If the element is an iportal-popup, don't scroll and prevent the browser's
	 * default behaviour.
	 *
	 * @param  {String} href
	 * @return {Boolean} - Was the href an anchor.
	 */
	p.scrollIfAnchor = function( href, pushToHistory ) {
		var match, anchorOffset;

		if ( ! ANCHOR_REGEX.test( href ) ) {
			return false;
		}

		match = document.getElementById( href.slice( 1 ) );
		if ( match ) {
			if ( match.classList.contains( 'iportal-popup' ) ) {
				return false;
			}
			var scroll = () => {
				anchorOffset = jQuery( match ).offset().top - this.getFixedOffset();
				jQuery( 'html, body' ).animate( { scrollTop: anchorOffset } );
			};
			// If we are inside a collapsing box, scroll again after content is shown.
			var collapsing = jQuery( match ).parents( '.collapse:not(.show)' );
			if ( collapsing.length ) {
				scroll();
				collapsing.first().one( 'shown.bs.collapse', scroll );
			} else {
				scroll();
			}
			// Add the state to history as-per normal anchor links
			if ( HISTORY_SUPPORT && pushToHistory ) {
				window.history.pushState( {}, window.document.title, window.location.pathname + href );
				window.dispatchEvent( new HashChangeEvent( 'hashchange' ) );
			}
		}

		return !!match;
	};

	/**
	 * Attempt to scroll to the current location's hash.
	 */
	p.scrollToCurrent = function( e ) {
		if ( this.scrollIfAnchor( window.location.hash ) && e ) {
			e.preventDefault();
		}
	};

	/**
	 * If the click event's target was an anchor, fix the scroll position.
	 */
	p.delegateAnchors = function( e ) {
		var elem = e.target;
		if ( elem.dataset.toggle !== 'modal'
				 && this.scrollIfAnchor( elem.getAttribute( 'href' ), true ) ) {
			e.preventDefault();
		}
	};
	return C;
} )();

export default AnchorJumps;
